export const GLOBAL_LANGUAGE_ID = "en" as const;
